import * as React from 'react'
import { useSelector } from 'react-redux'
import { Alert, Card, Typography } from 'antd'
import { FormattedMessage, FormattedDate } from 'react-intl'
import { getPeriodInfoAction, PeriodInfo } from './types'
import { FittedTable } from '../styled'
import Amount from '../Amount'
import DashboardSummary from './DashboardSummary'
import { useOnChangeHandler, usePaginatedData } from '../../redux'

const Home = () => {
  const { data, count, loading } = usePaginatedData(
    s => s.home.periodInfo,
    p => `${p.period}-${p.unitID}`
  )
  const { page, itemsPerPage } = useSelector(s => s.home.query)
  const onChangeHandler = useOnChangeHandler<PeriodInfo>(getPeriodInfoAction)

  return (
    <Alert.ErrorBoundary>
      <DashboardSummary />
      <Card>
        <Typography.Title level={3}>
          <FormattedMessage id="invoicesOverview" />
        </Typography.Title>
        <FittedTable
          size="middle"
          dataSource={data}
          loading={loading}
          pagination={{
            pageSize: itemsPerPage,
            current: page + 1,
            total: count,
          }}
          columns={[
            {
              dataIndex: 'period',
              title: <FormattedMessage id="period" />,
              render: (_, t) => (
                <FormattedDate value={t.period} year="numeric" month="short" />
              ),
            },
            {
              dataIndex: 'paid',
              title: <FormattedMessage id="paidInvoices" />,
              align: 'right',
              render: (_, t) => (
                <Amount amount={t.paidAmount} unit={t.unitID} />
              ),
            },
            {
              dataIndex: 'unpaid',
              title: <FormattedMessage id="unpaidInvoices" />,
              align: 'right',
              render: (_, t) => (
                <Amount amount={t.unpaidAmount} unit={t.unitID} />
              ),
            },
            {
              dataIndex: 'late',
              title: <FormattedMessage id="lateInvoices" />,
              align: 'right',
              render: (_, t) => (
                <Amount amount={t.lateAmount} unit={t.unitID} />
              ),
            },
          ]}
          onChange={onChangeHandler}
          scroll={{ y: '' }}
        />
      </Card>
    </Alert.ErrorBoundary>
  )
}

export default Home
